import React, { useRef, useState, useEffect } from 'react'
import LeftControl from '../../Components/LeftControl'
import { Button, Divider, Form, Input, Modal, Select, Table, message } from 'antd'
import { Grid } from '@material-ui/core'
import PageHeader from '../../Components/PageHeader'
import HardwareTable from '../../Components/TableComponents/HardwareTable'
import DynamicTable from '../../Components/TableComponents/DynamicTable'
import { dashTableColOther } from '../../Components/TableComponents/constants'
import { EditOutlined, EyeOutlined } from '@ant-design/icons'
import { Link, useHistory } from "react-router-dom";
import TableFilters from '../../Components/PayrollTicket/TableFilters'
import moment from 'moment'
import { showText } from '../../helpers/textValidation'
import Services from '../../Services';
import PgDynamicTable from '../../Components/TableComponents/PgDynamicTable'
import PageLayout from '../../Components/LayoutComponents/PageLayout'

const PayrollTicket = () => {

    const {
        payroll
    } = Services;
    const [edit, setEdit] = useState(false)
    const [filters, setFilters] = useState({})
    const [tickets, setTickets] = useState({})
    const [pagination, setPagination] = useState({
        limit: 10,
        offSet: 0,
    })
    const history = useHistory()

    const PayrollTickets = async () => {

        const response = await payroll.fetchPayrollTickets({ ...pagination, ...filters })
        if (response?.httpStatus != 200) return
        setTickets(response?.data)

    }

    const StatusCreator = (data) => {
        console.log(data,'dd')
        if (data?.Status == 'Rejected')
        return  data?.Supervisor?.firstName + " " + data?.Supervisor?.lastName + "-"+data?.Status
        if (data?.Status == 'Approval-Pending')
            return data?.Status
        if (![95, 96].includes(data?.TicketCategoryId))
            return 'N/A'
        if (data?.Supervisor)
            return data?.Supervisor?.firstName + " " + data?.Supervisor?.lastName + ' - Approved'
        if (!data?.ApproveSup)
            return 'N/A - No Supervisor'
    }

    let table = {
        header: [
            "Tck ID",
            "Name",
            "Ticket/Alert",
            "Open Date",
            "Category",
            "Approval Status",
            "Comments",
            "View",
        ],
        rows: tickets?.rows?.map((col, index) => [
            showText(col?.id),
            showText(col?.FEmployee ? col?.FEmployee?.firstName + " " + col?.FEmployee?.lastName : col?.employeeName),
            showText(col?.isAlert ? 'Alert' : 'Ticket'),
            col?.OpenDate ? moment(col?.OpenDate)?.utc()?.format("MM-DD-YYYY") : "N/A",
            <p style={{ width: "170px", overflow: 'hidden', whiteSpace: "wrap" }}>{col?.TicketCategory?.name ? col?.TicketCategory?.name : showText(col?.TicketCategoryText)}</p>,
            showText(StatusCreator(col)),
            showText(col?.creation_comment || 'N/A'),
            <Button
                className={col?.isCompleted ? "ViewIconNew" : "ViewIcon"}
                onClick={() => history.push('/payroll/ticket', { id: col?.id })}>
                <p></p>
            </Button>
        ])
    }

    useEffect(() => {
        PayrollTickets()
    }, [filters, pagination])


    return (
        <PageLayout className="Liq-Container HRPortal EmployeeResult" id='newHireQueuePage'>
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">Payroll Tickets/Alerts</Grid>
                <div>
                    <TableFilters setFilters={setFilters} filters={filters} />
                </div>
                <div>
                    <PgDynamicTable
                        tableData={table}
                        setPagination={setPagination}
                        pagination={pagination}
                        edit={edit}
                        count={tickets?.count} />
                </div>
            </Grid>
        </PageLayout>
    )
}

export default PayrollTicket